import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  sunImage: {
    height: Theme.px(100),
    marginBottom: Theme.px(85),
    width: Theme.px(100),
  },
  wrapper: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
});
